<div class="card" id="tile-loyalty-points-container">
  <div class="card-body">
    <div class="tile-header">
      <span class="h3">{{ loyaltyAmadeusPlusMe }}</span>
      <a *ngIf="!pointsState?.loadingError" class="link" routerLink="/amadeus-plus-me/bonuspoints">
        {{ loyaltyPointsTileFullReportLinkString }}</a
      >
    </div>
    <div class="row tile-content align-items-stretch">
      <div
        class="col-12 d-flex flex-column justify-content-between"
        *ngIf="!pointsState?.loadingError; else loadingError"
      >
        <ngb-alert
          *ngIf="
            enablePointBalanceBannerTile && expirationPointsEnabledForMarket && pointsState.data.toBeExpired !== null
          "
          class="mb-0 mt-4"
          dfInsertAlertIcon
          [dismissible]="false"
        >
          <strong *ngIf="pointsState?.data?.toBeExpired !== -9999; else noAccumulation" class="pe-6">
            {{ (pointsState?.data?.toBeExpired | number) || 0 }} {{ pointsExpiryString }}
            {{ lastDayOfMonth | reefDate: 'yyyy/MM/dd' }} {{ gmtConstantString }}</strong
          >
          <ng-template #noAccumulation>
            <strong class="pe-6"
              >{{ expiringConstantString }} {{ lastDayOfMonth | reefDate: 'yyyy/MM/dd' }} {{ gmtConstantString }} :
              {{ cronGenericFailureString }}</strong
            >
          </ng-template>
        </ngb-alert>
        <div class="tile-loyalty-points-block">
          <p class="tile-loyalty-points-item text-gray">
            <span i18n="@@loyalty-points-tile.loyaltyPointsTileRegular">Regular</span>
            <span id="regular-points">
              {{ (pointsState?.data?.regular | number) || 0 }} {{ loyaltyPointsTilePointsString }}
            </span>
          </p>
          <p class="tile-loyalty-points-item text-gray">
            <span i18n="@@loyalty-points-tile.loyaltyPointsTileAdditional">Additional</span>
            <span id="additional-points">
              {{ pointsState?.data?.additional ? '+ ' + (pointsState?.data?.additional | number) : 0 }}
              {{ loyaltyPointsTilePointsString }}
            </span>
          </p>
          <p class="tile-loyalty-points-item text-gray">
            <span>{{ loyaltyPointsTileUsedString }}</span>
            <span id="used-points">
              {{ pointsState?.data?.used ? '- ' + (pointsState?.data?.used | number) : 0 }}
              {{ loyaltyPointsTilePointsString }}
            </span>
          </p>
          <p class="tile-loyalty-points-item text-gray">
            <span>{{ loyaltyPointsTileExpiredString }}</span>
            <span id="expired-points">
              {{ pointsState?.data?.expired ? '- ' + (pointsState?.data?.expired | number) : 0 }}
              {{ loyaltyPointsTilePointsString }}
            </span>
          </p>
          <hr class="mt-3 mb-3" />
          <p class="tile-loyalty-points-item text-gray fw-bold">
            <span i18n="@@loyalty-points-tile.loyaltyPointsTileAvailable">Available</span>
            <span id="available-points">
              {{ (pointsState?.data?.available | number) || 0 }} {{ loyaltyPointsTilePointsString }}
            </span>
          </p>
        </div>
        <div class="mt-4 mt-lg-0 d-grid">
          <p *ngIf="pointsState?.data?.edenredIsOff">
            Sorry, we're doing some important maintenance and your gift store is temporarily unavailable. Please come
            back tomorrow to order a gift.
          </p>

          <button
            id="loyalty-tile-order-gifts-button"
            type="button"
            class="btn btn-primary"
            (click)="handleClickByOrderGifts()"
            [disabled]="pointsState?.data?.edenredIsOff"
            i18n="@@loyalty-points-tile.loyaltyPointsTileOrderGiftsButton"
          >
            Order Gifts &nbsp;
            <span class="fa-arrow-up-right-from-square df-icon-wtd me-2"></span>
          </button>
        </div>
        <div class="mt-4 mt-lg-0">
          <label
            >{{ membershipIdLabelString }} <strong>{{ agentNumber }}</strong></label
          >
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #loadingError>
  <div class="col-12">
    <loading-error [innerDivClassName]="''" [message]="pointsState?.loadingError"></loading-error>
  </div>
</ng-template>
